<template>
   <dashboard-layout :page="page">
      <base-breadcrumb :breadcrumbs="breadcrumbs"></base-breadcrumb>
      <v-container fluid>
         <v-row justify="center">
            <v-col cols="12" md="10">
               <v-card outlined>
                  <v-card-title>Proposer Consent</v-card-title>
                  <v-card-text>
                     <v-alert v-if="!rows.length" type="info" dense>
                        You have no pending nomination consents.
                     </v-alert>

                     <v-expansion-panels v-else multiple>
                        <v-expansion-panel v-for="row in rows" :key="row.id">
                           <v-expansion-panel-header>
                              <div>
                                 <strong>{{ row.title }}</strong>
                                 <v-chip v-if="isExpired(row) && !row.successMessage" x-small color="grey" dark class="ml-2">Expired</v-chip>
                                 <span v-if="row.successMessage" class="success--text ml-2">— {{ row.successMessage }}</span>
                              </div>
                           </v-expansion-panel-header>
                           <v-expansion-panel-content>
                              <v-alert v-if="row.successMessage" type="success" dense>{{ row.successMessage }}</v-alert>
                              <v-alert v-if="row.errorMessage" type="error" dense v-html="row.errorMessage"></v-alert>

                              <v-row dense v-if="!row.successMessage">
                                 <v-col cols="12" md="3"><small><b>Nominee</b></small></v-col>
                                 <v-col cols="12" md="9"><small>{{ row.nominee }}</small></v-col>

                                 <v-col cols="12" md="3"><small><b>Seconder</b></small></v-col>
                                 <v-col cols="12" md="9"><small>{{ row.seconder }}</small></v-col>
                              </v-row>

                              <v-alert v-if="isExpired(row) && !row.successMessage" type="warning" dense>
                                    Consent window for this position has ended ({{ formatDate(row.dateend) }}).
                              </v-alert>
                              <v-form v-if="!row.successMessage && !isExpired(row)" class="mt-3">
                                 <v-text-field
                                    v-model="row.tac"
                                    label="TAC (from your email)"
                                    maxlength="6"
                                    outlined
                                    dense
                                 ></v-text-field>
                                 <div class="text-right">
                                    <v-btn color="error" outlined class="mr-2" :disabled="!row.tac || row.submitting" :loading="row.submitting && row.intent === 'decline'" @click="submit(row, false)">
                                       Decline
                                    </v-btn>
                                    <v-btn color="primary" :disabled="!row.tac || row.submitting" :loading="row.submitting && row.intent === 'agree'" @click="submit(row, true)">
                                       I Agree
                                    </v-btn>
                                 </div>
                              </v-form>
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                     </v-expansion-panels>
                  </v-card-text>
               </v-card>
            </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
const axios = require('axios')

export default {
   name: 'MOMNomProposerConsent',
   components: { DashboardLayout, BaseBreadcrumb },
   props: {
      nominations: { type: Array, default: () => [] },
   },
   data() {
      return {
         page: { title: 'Proposer Consent', icon: 'mdi-account-check' },
         breadcrumbs: [
            { text: 'Dashboard', disabled: false, to: '/dashboard' },
            { text: 'Proposer Consent', disabled: true },
         ],
         rows: [],
      }
   },
   mounted() {
      this.rows = (this.nominations || []).map((n) => ({
         ...n,
         tac: '',
         submitting: false,
         intent: null,
         successMessage: '',
         errorMessage: '',
      }))
   },
   methods: {
    
      isExpired(row) {
         if (!row.dateend) return false
         return new Date(row.dateend) < new Date()
      },

      formatDate(dateStr) {
         if (!dateStr) return ''
         return new Date(dateStr).toLocaleString()
      },

      submit(row, agree) {
         row.errorMessage = ''
         row.intent = agree ? 'agree' : 'decline'
         row.submitting = true
         const payload = { nomdata: JSON.stringify([{ id: row.id, proposerconsent: agree, tac: row.tac }]) }
         axios.post('/member/nomination/proposer/consent/submit', payload)
            .then(({ data }) => {
               if (data.status !== 'OK') {
                  row.errorMessage = data.error || 'Unable to submit your response.'
                  return
               }
               row.successMessage = agree
                  ? 'You have agreed to this nomination.'
                  : 'You have declined this nomination.'
            })
            .catch((error) => {
               row.errorMessage = error.response && error.response.data && error.response.data.message
                  ? error.response.data.message
                  : 'Unable to submit your response. Please try again.'
            })
            .finally(() => { row.submitting = false })
      },
   },
}
</script>